module.exports = __webpack_public_path__ + "img/partner_40.b4d2dd10.png";